<!-- Laout Box Component -->
<div class="cp-layout-box" [ngClass]="{'ignore-title': ignoreTitle}">
	<div class="cp-layout-box-header">
		<div class="cp-layout-box-header-inner-wrapper">
			<div class="cp-layout-box-header-title">
				<ng-content select="[cp-layout-box-header-title]"></ng-content>
			</div>
			<div class="cp-layout-box-header-content">
				<ng-content select="[cp-layout-box-header-content]"></ng-content>
			</div>
		</div>
	</div>
	<div class="cp-layout-box-content">
		<ng-content select="[cp-layout-box-content]"></ng-content>
	</div>
</div>
